import React, { useState } from "react";
import Navbar from "./Navbar";
import styles from "./styles/ProtectedLayout.module.scss";

import { Button } from "Components/CustomComponents";
import DeleteModal from "Components/Modals/DeleteModal";
import { logout } from "Data/features/authSlice";
import {
  useDeleteProfileMutation,
  useLogoutMutation,
} from "Data/services/userAuthApi";
import { getErrorMessage } from "Hooks/useErrorHandler";
import { IoMdAdd } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import { RootState } from "store";
import {
  MenuChatIcon,
  MenuDriversIcon,
  MenuHistoryIcon,
  MenuHomeIcon,
  MenuRoutesIcon,
} from "svg";
import {
  removeToken
} from "../../Data/services/localStorageService";
import { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { WEB_ROUTES } from "../../constants";
import LogoutModal from "../Modals/LogoutModal";

interface ProtectedLayoutProps {
  isSearchBar: boolean;
  isSettingButton?: boolean;
  children: React.ReactNode;
}

export const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({
  isSearchBar,
  isSettingButton,
  children,
}) => {
  const location = useLocation();
  const dispatch = useDispatch()

  const [collapsed, setCollapsed] = useState(window.innerWidth > 991);

  const [logoutModal, setLogoutModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);


  const { user: authUser } = useSelector((state: RootState) => state.auth)


  const navigate = useNavigate();
  // todo: menu
  const items = [
    {
      label: "Home",
      icon: <MenuHomeIcon />,
      route: WEB_ROUTES.HOME,
    },
    {
      label: "Routes",
      icon: <MenuRoutesIcon />,
      route: WEB_ROUTES.ROUTES,
    },
    {
      label: "Drivers",
      icon: <MenuDriversIcon />,
      route: WEB_ROUTES.DRIVERS,
    },
    {
      label: "Chat",
      icon: <MenuChatIcon />,
      route: WEB_ROUTES.CHAT,
    },
    {
      label: "History",
      icon: <MenuHistoryIcon />,
      route: WEB_ROUTES.HISTORY,
    },
    // {
    //   label: "Settings",
    //   icon: <MenuSettingIcon />,
    //   route: WEB_ROUTES.SETTING,
    // }
  ];

  const isActiveRoute = (route: string): boolean => {
    return matchPath(location.pathname, route) !== null;
  };

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClose = () => {
    setCollapsed(false);
  };

  // const handleViewProfile = () => {
  //   navigate(baseRoute(WEB_ROUTES.PROFILE));
  // };

  const handleLogoutModalOpen = () => {
    setLogoutModal(true);
  };

  const handleLogoutModalClose = () => {
    setLogoutModal(false);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  const [logoutUser, { isLoading }] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      const response = await logoutUser().unwrap();
      if (response.code === 200) {
        dispatch(logout())
        // navigate("/account");
        // window.location.reload();
        SuccessToast("Logged Out Successfully");
      }
    } catch (error) {
      // console.log("Logout Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  const [deleteProfile, { isLoading: deleteLoading }] =
    useDeleteProfileMutation();

  const handleDeleteAccount = async () => {
    // console.log("handleDeleteAccount");
    try {
      const response = await deleteProfile().unwrap();
      if (response.code === 200) {
        removeToken();
        navigate("/account");
        window.location.reload();
        SuccessToast("Delete Account Successfully.");
      }
    } catch (error) {
      // console.log("Logout Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  const handleCreateRoute = () => {
    navigate(WEB_ROUTES.CREATE_ROUTE);
  };

  return (
    <div className={styles.ProtectedLayout}>
      <div
        className={collapsed ? styles.background : ""}
        onClick={handleMenuClose}
      ></div>
      <div
        className={`${styles.menu} ${collapsed ? `${styles.collapsed} visible` : styles.notCollapsed
          }`}
        id="sider"
      >
        <div
          className={`${styles.logo} ${!collapsed ? styles.notCollapsed : ""}`}
        // to={"/dashboard"}
        >
          <img
            src={"/logo.png"} //todo:
            alt="Logo"
            className={`${styles.large} ${collapsed ? styles.imageCollapsed : styles.imageNotCollapsed
              }`}
            width={"100%"}
            height={"60%"}
          />
          <img
            src={"/logo_small.png"} //todo:
            alt="Logo"
            className={`${styles.small} ${collapsed ? styles.imageCollapsed : styles.imageNotCollapsed
              }`}
            width={"100%"}
            height={"60%"}
          />
        </div>
        <div className={styles.profileContainer}>
          <img
            // src="/images/user_image.png"
            src={authUser?.image_url}
            alt="Profile Image"
            className={styles.image}
          />
          <div
            className={`${styles.infoContainer} ${!collapsed ? styles.notCollapsed : ""
              }`}
          >
            <h5 className={`${styles.name} lc-1`}>{authUser?.username}</h5>
            <p className={`${styles.description} lc-1`}>
              <span className={styles.label}>Employee ID :</span>
              <span className={styles.number}>
                <span className="lc-1">{authUser?.id}</span>
              </span>
            </p>
          </div>
        </div>
        <div
          className={`${styles.createRouteContainer} ${!collapsed ? styles.notCollapsed : ""
            }`}
        >
          <Button
            text={collapsed ? "Create Routes" : <IoMdAdd size={25} />}
            classes="blueBtnBg"
            onClick={handleCreateRoute}
          />
        </div>

        {/* <div className={`${styles.drawer} ${collapsed ? styles.collapsed : ''}`}>

                    <span onClick={handleToggle}>
                        <BiLogOut />
                    </span>
                </div> */}

        {items.map(({ icon, label, route }, index) => {
          return (
            <Link
              to={route}
              className={`${styles.item} ${isActiveRoute(route) ? styles.active : ""
                }`}
              key={index}
            >
              <span style={{ fontSize: "20px", display: "flex" }}>{icon}</span>
              {collapsed ? <p>{label}</p> : ""}
            </Link>
          );
        })}
        {/* <Link
          className={styles.item}
          onClick={handleLogoutModalOpen}
          to={""}
        >
          <span style={{ fontSize: "20px", display: "flex" }}>

            <TbLogout2 />
          </span>
          {collapsed ? <p>Logout</p> : ""}
        </Link> */}
      </div>
      <div className={styles.routeContent}>
        {logoutModal ? (
          <LogoutModal
            handleLogoutModalClose={handleLogoutModalClose}
            data={""}
            loading={isLoading}
            onLogout={handleLogout}
          />
        ) : null}
        {deleteModal ? (
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={null}
            loading={deleteLoading}
            onDelete={handleDeleteAccount}
          />
        ) : null}
        <Navbar
          isSearchBar={isSearchBar}
          isSettingButton={isSettingButton}
          handleToggle={handleToggle}
          logoutModalHandler={handleLogoutModalOpen}
          deleteUserModalHandler={handleDeleteModalOpen}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};
